import type { ChoiceValue } from "../../../domain/contracts";
import { incidentLabelFallbacks, type IncidentLabelGroupKey } from "./incidentLabelFallbacks";

function normalizeCode(code: string | null | undefined): string {
  return (code ?? "").trim();
}

export function humanizeCode(code: string | null | undefined): string {
  const normalized = normalizeCode(code);
  if (!normalized) {
    return "Unknown";
  }

  return normalized
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function resolveIncidentCodeLabel(
  code: string | null | undefined,
  group: IncidentLabelGroupKey,
): string {
  const normalized = normalizeCode(code);
  if (!normalized) {
    return "Unknown";
  }

  return incidentLabelFallbacks[group][normalized] ?? humanizeCode(normalized);
}

export function resolveChoiceValueLabel(
  value: ChoiceValue | null | undefined,
  group: IncidentLabelGroupKey,
): string {
  if (!value) {
    return "Unknown";
  }

  if (value.label && value.label.trim()) {
    return value.label.trim();
  }

  return resolveIncidentCodeLabel(value.code, group);
}

export function resolveChoiceValueListLabels(
  values: ChoiceValue[] | null | undefined,
  group: IncidentLabelGroupKey,
): string[] {
  if (!values || values.length === 0) {
    return [];
  }

  return values.map((value) => resolveChoiceValueLabel(value, group));
}
